import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import { ReportListView } from './ReportListView'

export const ReportsView: React.FC = () => {
  return (
    <Routes>
      <Route path="" element={<ReportListView />} />
      {/* Future routes can be added here following the same pattern as EventsView:
          <Route path="show/:id" element={<ReportDetailView />} />
          <Route path="edit/:id" element={<ReportEditView />} />
      */}
      <Route path="*" element={<Navigate to="/admin/reports" replace />} />
    </Routes>
  )
}
